/** refetchInterval that polls every `ms` only while the page is visible (nothing in the background). */
export const visibleInterval = (ms: number) => () => (typeof document !== 'undefined' && document.visibilityState === 'visible' ? ms : false);
